// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1645019819340
      var cssReload = require("/var/www/bm-sites.ru/data/www/bm-sites.ru/opengeology/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"reloadAll":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  